import { render, staticRenderFns } from "./Reciboslist-verNet.vue?vue&type=template&id=32840d0c"
import script from "./Reciboslist-verNet.vue?vue&type=script&lang=js"
export * from "./Reciboslist-verNet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports